import api from "@/api/v1-jwt/config/api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  RecurringInvoiceSchedule,
  RecurringInvoiceScheduleSchema,
} from "../types";
import { invoiceQueryKeys } from "../query-keys";
import { z } from "zod";

const fetchRecurringInvoices = async (
  userId: string
): Promise<RecurringInvoiceSchedule[]> => {
  const url = `/platform/invoices/${userId}/recurring`;
  const response = await api.get(url);
  return z.array(RecurringInvoiceScheduleSchema).parse(response.data.data);
};

export const recurringInvoiceList = {
  queryOptions: (
    userId: string,
    options?: Omit<
      UseQueryOptions<RecurringInvoiceSchedule[], Error>,
      "queryKey" | "queryFn"
    >
  ) => ({
    queryKey: invoiceQueryKeys.recurringInvoice.list(userId),
    queryFn: () => fetchRecurringInvoices(userId),
    enabled: !!userId,
    ...options,
  }),
  useQuery: (
    userId: string,
    options?: Omit<
      UseQueryOptions<RecurringInvoiceSchedule[], Error>,
      "queryKey" | "queryFn"
    >
  ) => {
    return useQuery<RecurringInvoiceSchedule[], Error>(
      recurringInvoiceList.queryOptions(userId, options)
    );
  },
};
